import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import AuthPage from "./AuthPage";
import BasePage from "./BasePage";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import CashierDisplay from "./pages/display/cashier_display/CashierDisplay";
import MedicineDisplay from "./pages/display/medicine_display/MedicineDisplay";
// import DisplayQueue from "./pages/display/display_queue/DisplayQueue";
import DoctorQueueDisplay from "./pages/display/display_queue/DoctorQueueDisplay";

export function Routes() {
    const isAuthorized = JSON.parse(localStorage.getItem("authToken"));
    return (
        <Switch>
            {/* Old Display Doctor */}
            {/* <Route exact path="/display/doctor-display" component={DisplayQueue} /> */}

            {/* New Display Doctor */}
            <Route exact path="/display/doctor-display" component={DoctorQueueDisplay} />

            <Route exact path="/display/medicine-display" component={MedicineDisplay} />
            <Route exact path="/display/cashier-display" component={CashierDisplay} />

            {!isAuthorized ? (
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                <Redirect from="/auth" to="/" />
            )}

            <Route path="/error" component={ErrorsPage} />
            {/* <Route path="/logout" component={Logout} /> */}

            {!isAuthorized ? (
                <Redirect to="/auth/login" />
            ) : (
                <Layout>
                    <BasePage />
                </Layout>
            )}
        </Switch>
    );
}
